/**
 * Path to the Ask AI chat. The chat is mounted twice: `/ai-chat` inside the
 * self-managed app (where the dashboard's Topics tab lives) and `/aiChat` in
 * the classic app. Same discriminator the ootils helpers use
 * (SELF_MANAGED_BASE_CONFIGS.enable).
 *
 * `anchor` ({ nodeId, lens?, kind?, title? }) deep-links the chat pre-anchored
 * to a Topics-tab node: the chat page reads the params on mount and asks that
 * topic's suggested question straight away.
 *
 * Dependency-free on purpose (testable without ootils); re-exported from
 * routePathGenerators.js beside the ootils helpers.
 */
export const getRoutePathToAiChat = ({ SELF_MANAGED_BASE_CONFIGS, anchor } = {}) => {
  const base = SELF_MANAGED_BASE_CONFIGS?.enable ? "/ai-chat" : "/aiChat";
  if (!anchor?.nodeId) return base;
  const params = new URLSearchParams();
  params.set("anchor", String(anchor.nodeId));
  if (anchor.lens) params.set("lens", anchor.lens);
  if (anchor.kind) params.set("kind", anchor.kind);
  if (anchor.title) params.set("title", anchor.title);
  return `${base}?${params.toString()}`;
};
